export default __webpack_public_path__ + "static/media/imge1.768032bd.jpg";